import { pascalToSentence as m } from "../../lib/utils.js";
import c from "./ArrowDownwards.js";
import p from "./ArrowDown.js";
import f from "./ArrowRight.js";
import I from "./ArrowLeft.js";
import a from "./ArrowUp.js";
import s from "./ArrowUpwards.js";
import d from "./Baseline.js";
import w from "./Bed.js";
import C from "./ChevronDown.js";
import l from "./ChevronLeft.js";
import h from "./ChevronRight.js";
import u from "./ChevronUp.js";
import D from "./Close.js";
import i from "./Device.js";
import L from "./Download.js";
import v from "./Expand.js";
import A from "./Heart.js";
import S from "./Lungs.js";
import E from "./Minus.js";
import g from "./More.js";
import k from "./Patient.js";
import O from "./Plus.js";
import U from "./Search.js";
import N from "./Settings.js";
import B from "./Share.js";
import G from "./TimeLine.js";
import M from "./Vitals.js";
import P from "./Medication.js";
import R from "./Site.js";
import x from "./Dashboard.js";
import b from "./Group.js";
import j from "./GroupPatient.js";
import y from "./Report.js";
import T from "./Goal.js";
import H from "./User.js";
import V from "./Consent.js";
import q from "./Ews.js";
import z from "./BedEmpty.js";
import F from "./DeviceLowSignal.js";
import J from "./DeviceOffline.js";
import Q from "./Notification.js";
import W from "./Note.js";
import X from "./SoundOff.js";
import Y from "./Copy.js";
import Z from "./Emr.js";
import _ from "./Conditions.js";
import $ from "./Chart.js";
import K from "./Delete.js";
import oo from "./Adjust.js";
import ro from "./Check.js";
import no from "./Edit.js";
import mo from "./Compose.js";
import to from "./ExternalLink.js";
import io from "./LockClosed.js";
import eo from "./LockOpen.js";
const e = {
  Adjust: oo,
  ArrowDownwards: c,
  ArrowDown: p,
  ArrowRight: f,
  ArrowLeft: I,
  ArrowUp: a,
  ArrowUpwards: s,
  Baseline: d,
  Bed: w,
  BedEmpty: z,
  Chart: $,
  Check: ro,
  ChevronDown: C,
  ChevronLeft: l,
  ChevronRight: h,
  ChevronUp: u,
  Close: D,
  Compose: mo,
  Conditions: _,
  Consent: V,
  Copy: Y,
  Dashboard: x,
  Delete: K,
  Device: i,
  DeviceLowSignal: F,
  DeviceOffline: J,
  DeviceOnline: i,
  Download: L,
  Edit: no,
  Emr: Z,
  Ews: q,
  Expand: v,
  ExternalLink: to,
  Goal: T,
  Group: b,
  GroupPatient: j,
  Heart: A,
  LockClosed: io,
  LockOpen: eo,
  Lungs: S,
  Medication: P,
  Minus: E,
  More: g,
  Note: W,
  Notification: Q,
  Patient: k,
  Plus: O,
  Report: y,
  Search: U,
  Setting: N,
  Site: R,
  Share: B,
  SoundOff: X,
  TimeLine: G,
  User: H,
  Vitals: M
}, t = Object.keys(e);
t.map(m);
t.reduce((r, o) => {
  const n = m(o);
  return {
    ...r,
    [n]: e[o]
  };
}, {});
t.reduce((r, o) => {
  const n = m(o);
  return {
    ...r,
    [o]: n
  };
}, {});
export {
  e as default,
  t as iconNames
};
